class CustomSubscriptionHandler {
    constructor() {
        document.addEventListener('DOMContentLoaded', () => {
            this.initRadios();
            this.initRechargeListeners();
        });
    }

    initRadios() {
        const radios = document.querySelectorAll('.form-container input[type="radio"]');
        radios.forEach(radio => {
            radio.addEventListener('change', () => {
                this.clearRadioClasses(radios);
                if (radio.checked) {
                    radio.parentNode.classList.add('radio-selected');
                }
            });
        });
        radios[0].click();
    }

    clearRadioClasses(radios) {
        radios.forEach(radio => {
            radio.parentNode.classList.remove('radio-selected');
        });
    }

    initRechargeListeners() {
        window.addEventListener('ReChargeWidget-loaded', () => {
            setTimeout(() => {
                this.handleRechargeRadios();
            }, 2000);
        });
    }

    handleRechargeRadios() {
        const formContainer = document.querySelector('.sticky-add-to-cart .form-container');
        const autoReplenishRadio = document.querySelector('input[name="subscription"][value="auto-replenish"]');
        const oneTimePurchaseRadio = document.querySelector('input[name="subscription"][value="one-time-purchase"]');
        const stickyAtcButton = document.getElementById('sticky-atc');

        const rechargeAutoReplenish = document.querySelector('[data-radio-subsave]');
        const rechargeOneTimePurchase = document.querySelector('[data-radio-onetime]');

        if (!rechargeAutoReplenish || !rechargeOneTimePurchase) return;

        formContainer.querySelector("#subscription-options").classList.remove("hidden");

        rechargeAutoReplenish.addEventListener('click', () => autoReplenishRadio?.click());
        rechargeOneTimePurchase.addEventListener('click', () => oneTimePurchaseRadio?.click());

        autoReplenishRadio.addEventListener('click', () => rechargeAutoReplenish?.click());
        oneTimePurchaseRadio.addEventListener('click', () => rechargeOneTimePurchase?.click());

        stickyAtcButton.addEventListener('click', () => {
            document.querySelector('.cta-gig-primary.js-go-cart-add-to-cart').click();
        });
    }
}

// Instantiate the handler to initialize functionality
new CustomSubscriptionHandler();
